import { DeferredPage } from "@/components/data-display/deferred-page";

// Deferred (page-delivery-pipeline.md G6, 2026-09-23). No liquidity backend exists in this
// environment: the RFQ route quotes and requester name were previously fabricated. See
// context/page_pipeline/BOARD.md wave 4 and context/page_pipeline/BACKEND_GAPS.md.
export default function TreasuryLiquidityQuotePage() {
  return (
    <DeferredPage
      nav={{ kind: "breadcrumb", parents: [{ label: "Treasury", href: "/treasury" }, { label: "Liquidity Dashboard", href: "/treasury/liquidity" }], label: "Quote / RFQ Flow" }}
      state={{
        title: "Quote / RFQ Flow is not available in this environment yet",
        description: "Requesting and comparing liquidity quotes requires the RFQ/venue backend, which does not exist in this environment yet.",
      }}
    />
  );
}
